const Footer = () => {
  const currentDate = new Date();

  return (
    <footer className="w-full p-6 bg-black text-white">
      <p className="text-center text-sm text-gray-300">
        &copy; {currentDate.getFullYear()} Celebration Church International. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
